import { ISettings } from 'my-poppies-b2b-types';
import { sleep } from 'sleep-lightweight';

import { dummyDataSettings } from '@/dummyData/dummyDataSettings';

export const mockApiCallForSettings = async (): Promise<ISettings> => {
  await sleep(250);
  return dummyDataSettings;
};
